module.exports = __webpack_public_path__ + "static/media/Logo-N4L3.6ec0fe69.png";